import { AnimatePresence, motion } from 'framer-motion';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import { useEffect, useState } from 'react';

import { PageHeader } from '@core/components/page-header';
import { useNavigate } from '@core/hooks/navigate.hook';
import { mergeRoutes } from '@core/lib/merge-routes';
import { Routes } from '@core/constants/routes';

import { usePersonalStore } from '../store';
import { Container } from '@mui/material';
import { PersonalContextProvider } from '../context/personal.context';

export function PersonalLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { idCampaign } = useParams<{ idCampaign: string }>();

  const [loading, setLoading] = useState(true);

  const layoutInfo = usePersonalStore((state) => state.layout);
  const campaignId = usePersonalStore((state) => state.campaign);

  const setPersonId = usePersonalStore((state) => state.setPersonId);
  const setCampaignId = usePersonalStore((state) => state.setCampaignId);

  const handleBackClick = () => {
    if (
      location.pathname ===
      mergeRoutes([
        Routes.CAMPAINGS,
        Routes.CREATE,
        Routes.MANAGE_PERSONAL,
        Routes.EDIT,
      ])
    ) {
      setPersonId(undefined);
    }
  };

  useEffect(() => {
    // For edit routes, get campaignId from URL params
    // For create routes, get it from state
    const currentCampaignId = idCampaign || location.state?.campaignId || campaignId;
    
    if (!currentCampaignId) {
      navigate([Routes.CAMPAINGS]);
      return;
    }

    if (location.state?.campaignId || idCampaign) {
      setCampaignId(location.state?.campaignId || idCampaign);
    }

    if (currentCampaignId) {
      setLoading(false);
    }
  });

  return (
    <PersonalContextProvider>
      <PageHeader
        key={`${location.pathname}-header`}
        title={layoutInfo.title}
        subtitle={layoutInfo.subtitle}
        titleProps={{
          Icon: PersonIcon,
        }}
        backLink={layoutInfo.backLink}
        backLinkOpts={
          idCampaign
            ? { backLinkParams: { idCampaign } }
            : undefined
        }
        onBackClick={handleBackClick}
      />
      <Container
        sx={{
          height: { lg: '100%' },
          px: { xs: 0, md: 'inherit' },
          maxWidth: { lg: layoutInfo.stretch ? 390 : 'auto' },
          pb: 4,
        }}
      >
        <Outlet />
      </Container>
      <AnimatePresence>
        {loading && (
          <motion.div
            className='fixed w-full h-[calc(100%-4.5rem)] bg-white top-[4.5rem] left-0'
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        )}
      </AnimatePresence>
    </PersonalContextProvider>
  );
}
